<template>

	<div class="lobby-default-theme">

		<div class="lobby-heading-body">

			<div class="visible-pc">

				<div class="pc-heading">

					<div class="container">
						<img class="wp100 cursor" v-if="topic.poster && topic.poster.url"
						     @click.stop.prevent="$router.push('/'+topic.location)" :src="topic.poster.url"/>
						<div v-if="!topic.loading && (!topic.poster || !topic.poster.url)"
						     @click.stop.prevent="$router.push('/'+topic.location)"
						     class="poster-title">
							{{topic.name}}
						</div>
					</div>

					<div class="bg-999" style="height: 1px"></div>

					<div class="container">

						<MenuBarView :menus="topic.menus" :autoLength="false"/>

					</div>

				</div>
			</div>

			<div class="visible-mobile">

				<div class="mobile-heading">

					<div>
						<img class="wp100 cursor" v-if="topic.poster && topic.poster.url"
						     @click.stop.prevent="$router.push('/'+topic.location)" :src="topic.poster.url"/>
						<div v-if="!topic.loading && (!topic.poster || !topic.poster.url)"
						     @click.stop.prevent="$router.push('/'+topic.location)"
						     class="poster-title"
						>
							{{topic.name}}
						</div>
					</div>


					<a class="btn btn-primary btn-circle menu-trigger" href="javascript:void(0)" @click="showMenu=!showMenu">
						<i v-show="!showMenu" class="fa fa-list"></i>
						<i v-show="showMenu" class="fa fa-times"></i>
					</a>

					<MenuListView :menus="topic.menus" v-model="showMenu"/>

				</div>
			</div>


			<div class="container">

				<div class="row">
					<div class="col-md-9">
						<router-view></router-view>
					</div>
					<div class="col-md-3 mt20">

						<ItemBlock v-for="block in blocks" :key="block" :block="block"/>

					</div>
				</div>


			</div>

		</div>

		<FooterView/>

	</div>


</template>

<script>

	import MenuBarView from "./widget/MenuBarView.vue";
	import MenuListView from "./widget/MenuListView.vue";
	import FooterView from "./widget/FooterView.vue";
	import ItemBlock from "./widget/ItemBlock.vue";

	import Block from '../../../common/model/lover/theme/Block'
	import Item from '../../../common/model/lover/theme/Item'

	export default {
		data () {
			return {
				user: this.$store.state.user,
				blocks: [],
				showMenu: false
			}
		},
		computed: {
			topic(){
				return this.$route.meta.topic;
			}
		},
		components: {
			MenuBarView,
			MenuListView,
			FooterView,
			ItemBlock
		},
		watch: {},
		methods: {
			refresh(){
			}
		},
		created(){

		},
		mounted(){
			//从topic中将Block提取出来。
			let arr = JSON.parse(this.topic.remark);
			if (arr instanceof Array) {

				//首先清空现有的。
				this.blocks.splice(0, this.blocks.length);
				for (let i = 0; i < arr.length; i++) {
					let obj = arr[i];
					let block = new Block();
					block.render(obj);
					this.blocks.push(block);
				}

			}
		}
	}

</script>


<style lang="less" rel="stylesheet/less">


	//菜单样式
	.lobby-default-theme {

		@main-color: #333;

		height: 100%;
		position: relative;
		padding-bottom: 60px;

		.lobby-heading-body {
			min-height: 100%;

			.pc-heading {
				background-color: @main-color;

			}

			.mobile-heading {
				position: relative;
				background-color: @main-color;

				.menu-trigger {
					position: absolute;
					right: 15px;
					top: 15px;
				}
			}

		}

		//没有海报时候的样式.
		.poster-title {
			color: white;
			font-size: 30px;
			padding: 20px 10px;
			cursor: pointer;
		}

	}
</style>




// WEBPACK FOOTER //
// DefaultTheme.vue?eab8975c